import { PM_PROVIDERS } from 'common/constants/constants';
import notConnectedCHImg from 'images/pulse-not-connected-ch.svg';
import notConnectedImg from 'images/pulse-not-connected.svg';
import { LBAzureBoardsIcon, LBJiraIcon, LBShortcutIcon } from '@linearb/buzz';

export const CIRCLES_WIDTH = 3;
export const CIRCLES_HEIGHT = 2;
export const CIRCLE_SIZES = {
  S: 1,
  M: 1.5,
  L: 2
};
export const CIRCLE_TYPES = {
  DEPLOY: 'DEPLOY',
  MERGE: 'MERGE',
  ACTIVE: 'ACTIVE'
};
export const PULSE_EMPTY_STATES = {
  NO_PM_CONNECTED: 'NO_PM_CONNECTED',
  UNCONFIGURED_TEAM: 'UNCONFIGURED_TEAM',
  NO_TEAM_SELECTED: 'NO_TEAM_SELECTED',
  TOO_LONG_ITERATION: 'TOO_LONG_ITERATION',
  LOADING_PAST_ITERATIONS: 'LOADING_PAST_ITERATIONS'
};

export const ISSUE_STATES = {
  DONE: 'done',
  INITIATED: 'created',
  IN_PROGRESS: 'in-progress',
  NONE: 'none'
};

export const MAX_ISSUES_FOR_TOGGLE_UNMATCHED = 4;

const MAP_ISSUE_STATES_TO_BRANCH_STATE = {
  done: ['deployed', 'merged'],
  created: [],
  'in-progress': ['active'],
  none: []
};

export const mapIssueStatesToBranchStates = issueStates => {
  return issueStates.reduce(
    (arr, issueState) => [
      ...arr,
      ...MAP_ISSUE_STATES_TO_BRANCH_STATE[issueState]
    ],
    []
  );
};
export const ISSUE_STATES_DISPLAY_VALUES = {
  [ISSUE_STATES.DONE]: {
    text: 'Done',
    tagColors: { text: 'funGreen', border: 'pastelGreen', background: 'madang' }
  },
  [ISSUE_STATES.INITIATED]: {
    text: 'To do',
    tagColors: {
      text: 'shuttleGray',
      border: 'botticelli',
      background: 'white'
    }
  },
  [ISSUE_STATES.IN_PROGRESS]: {
    text: 'WIP',
    tagColors: { text: 'chambray', border: 'fog', background: 'titanWhite' }
  },
  [ISSUE_STATES.NONE]: {
    // handle no issue state as To Do
    text: 'To do',
    tagColors: {
      text: 'shuttleGray',
      border: 'botticelli',
      background: 'white'
    }
  }
};

const calcCircleSizeBasedOnCodeChanges = codeChanges => {
  if (codeChanges > 300) {
    return CIRCLE_SIZES.L;
  }
  if (codeChanges > 100) {
    return CIRCLE_SIZES.M;
  }
  return CIRCLE_SIZES.S;
};

const calcCircleSizeBasedOnCommitCount = commitCount => {
  if (commitCount > 6) {
    return CIRCLE_SIZES.L;
  }
  if (commitCount > 3) {
    return CIRCLE_SIZES.M;
  }
  return CIRCLE_SIZES.S;
};

export const getCircleObject = (circleType, eventCount, isGrayedOut) => {
  const _getCircleObject = (circleType, eventCount) => {
    const size =
      circleType === CIRCLE_TYPES.ACTIVE
        ? calcCircleSizeBasedOnCommitCount(eventCount)
        : calcCircleSizeBasedOnCodeChanges(eventCount);
    switch (circleType) {
      case CIRCLE_TYPES.DEPLOY:
        return { size, color: 'malachite', opacity: 0.8 };
      case CIRCLE_TYPES.MERGE:
        return { size, color: 'pastelGreen', opacity: 0.8 };
      case CIRCLE_TYPES.ACTIVE:
      default:
        return { size, color: 'dodgerBlue', opacity: 0.8 };
    }
  };

  return isGrayedOut
    ? {
        ..._getCircleObject(circleType, eventCount),
        color: 'alto'
      }
    : _getCircleObject(circleType, eventCount);
};

export const getEmptyStateByPmSensor = pmSensor => {
  switch (pmSensor) {
    case PM_PROVIDERS.CLUBHOUSE:
      return {
        pulseImage: notConnectedCHImg,
        name: 'Shortcut project',
        buttonText: 'Select project',
        logo: LBShortcutIcon,
        pathParam: 'clubhouse',
        clickType: 'CONNECT_PROJECT'
      };
    case PM_PROVIDERS.JIRA:
      return {
        pulseImage: notConnectedImg,
        name: 'Jira board',
        buttonText: 'Select Jira Board',
        logo: LBJiraIcon,
        pathParam: 'jira',
        clickType: 'CONNECT_BOARD'
      };
    case PM_PROVIDERS.AZURE_BOARDS:
      return {
        pulseImage: notConnectedImg,
        name: `scope`,
        buttonText: 'Select team scope',
        logo: LBAzureBoardsIcon,
        pathParam: 'azure_boards',
        clickType: 'CONNECT_TEAM_SCOPE'
      };
    default:
      return {
        pulseImage: notConnectedImg,
        name: 'Jira board',
        buttonText: 'Select Jira Board',
        logo: LBJiraIcon,
        pathParam: 'jira',
        clickType: 'CONNECT_BOARD'
      };
  }
};
